(function () {
  var initTimeout = null;
  var reinitRaf1 = null;
  var reinitRaf2 = null;
  var tolstoyReadyBound = false;

  function getSections() {
    return Array.prototype.slice.call(
      document.querySelectorAll(".pdp-v2--main[data-section-id]")
    );
  }

  function isVisible(el) {
    if (!el) return false;

    var style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") {
      return false;
    }

    return el.getClientRects().length > 0;
  }

  function getCandidate(section, selector) {
    var candidates = Array.prototype.slice.call(section.querySelectorAll(selector));
    var i;

    for (i = 0; i < candidates.length; i += 1) {
      if (isVisible(candidates[i])) {
        return candidates[i];
      }
    }

    return candidates.length ? candidates[0] : null;
  }

  function destroySectionSliders(section) {
    if (section.__pdpV2MainSlider && section.__pdpV2MainSlider.destroy) {
      section.__pdpV2MainSlider.destroy(true, true);
      section.__pdpV2MainSlider = null;
    }

    if (section.__pdpV2ThumbsSlider && section.__pdpV2ThumbsSlider.destroy) {
      section.__pdpV2ThumbsSlider.destroy(true, true);
      section.__pdpV2ThumbsSlider = null;
    }

    section.__pdpV2SecondClick = false;
  }

  function attachThumbsReset(section, buttonEl, thumbsInstance) {
    if (!buttonEl) return;
    if (buttonEl.__pdpV2Bound) return;

    buttonEl.__pdpV2Bound = true;

    buttonEl.addEventListener("click", function () {
      if (this.classList.contains("swiper-button-disabled")) {
        if (section.__pdpV2SecondClick) {
          thumbsInstance.slideTo(0, 200, true);
          section.__pdpV2SecondClick = false;
        } else {
          section.__pdpV2SecondClick = true;
        }
      } else {
        section.__pdpV2SecondClick = false;
      }
    });
  }

  function initSectionSliders(section) {
    var thumbsButton;
    var thumbsInstance = null;
    var mainNextBtn;
    var mainPrevBtn;
    var paginationEl;
    var mainInstance;
    var mainSliderEl;
    var thumbsSliderEl;

    if (typeof window.Swiper !== "function") {
      return false;
    }

    if (!section) {
      return false;
    }

    mainSliderEl = getCandidate(section, ".mySwiper2");
    if (!mainSliderEl) {
      return false;
    }

    thumbsSliderEl = getCandidate(section, ".mySwiper");

    destroySectionSliders(section);

    if (thumbsSliderEl) {
      thumbsButton = thumbsSliderEl.querySelector(".button-next");

      thumbsInstance = new window.Swiper(thumbsSliderEl, {
        spaceBetween: 0,
        slidesPerView: 4.7,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: thumbsButton,
          prevEl: null,
        },
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,
        breakpoints: {
          1023: {
            slidesPerView: "auto",
            direction: "vertical",
          },
        },
      });

      attachThumbsReset(section, thumbsButton, thumbsInstance);
      section.__pdpV2ThumbsSlider = thumbsInstance;
      window.pdpV2ThumbsSlider = thumbsInstance;
    } else {
      window.pdpV2ThumbsSlider = null;
    }

    mainNextBtn = mainSliderEl.querySelector(".swiper-button-next");
    mainPrevBtn = mainSliderEl.querySelector(".swiper-button-prev");
    paginationEl = mainSliderEl.querySelector(".swiper-pagination");

    mainInstance = new window.Swiper(mainSliderEl, {
      spaceBetween: 0,
      slidesPerView: 1,
      thumbs: thumbsInstance ? { swiper: thumbsInstance } : undefined,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      breakpoints: {
        1023: {
          slidesPerView: 1,
        },
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: mainNextBtn,
        prevEl: mainPrevBtn,
      },
    });

    mainInstance.slideTo(0, 0, false);
    mainInstance.update();

    section.__pdpV2MainSlider = mainInstance;
    window.pdpV2MainSlider = mainInstance;

    return true;
  }

  function initPdpV2Sliders() {
    var sections = getSections();
    var initialized = false;
    var i;

    for (i = 0; i < sections.length; i += 1) {
      try {
        initialized = initSectionSliders(sections[i]) || initialized;
      } catch (error) {
        window.pdpV2MainSlider = null;
      }
    }

    return initialized;
  }

  function attemptInitPdpV2Sliders(attempt) {
    var nextAttempt = typeof attempt === "number" ? attempt : 0;

    if (initPdpV2Sliders()) {
      return true;
    }

    if (nextAttempt < 10) {
      setTimeout(function () {
        attemptInitPdpV2Sliders(nextAttempt + 1);
      }, 200);
    }

    return false;
  }

  function scheduleInit(delay) {
    if (initTimeout) {
      clearTimeout(initTimeout);
    }

    initTimeout = setTimeout(function () {
      attemptInitPdpV2Sliders(0);
    }, typeof delay === "number" ? delay : 250);
  }

  function queueInitPdpV2Sliders() {
    if (reinitRaf1) {
      cancelAnimationFrame(reinitRaf1);
    }

    if (reinitRaf2) {
      cancelAnimationFrame(reinitRaf2);
    }

    reinitRaf1 = requestAnimationFrame(function () {
      reinitRaf2 = requestAnimationFrame(function () {
        scheduleInit(0);
      });
    });
  }

  function updateSliders() {
    setTimeout(function () {
      queueInitPdpV2Sliders();
    }, 250);
  }

  function updateProductDescription() {
    if (
      !window.tolstoyWidget ||
      typeof window.tolstoyWidget.postMessage !== "function"
    ) {
      return;
    }

    window.tolstoyWidget.postMessage({
      eventName: "tolstoy_product_update",
      product: {
        id: "7285536194717",
        descriptionHtml:
          "<div>" +
          "<h3 style=\"margin: 0;\">Includes:</h3>" +
          "<ul style=\"padding: 0 20px; margin: 0;\">" +
          "<li style=\"list-style: disc\">1 Jolie</li>" +
          "<li style=\"list-style: disc\">1 Filter</li>" +
          "<li style=\"list-style: disc\">Filter subscription</li>" +
          "</ul>" +
          "</div>",
      },
    });
  }

  function bindTolstoyListener() {
    if (tolstoyReadyBound) {
      return;
    }

    tolstoyReadyBound = true;
    window.addEventListener("tolstoyWidgetReady", updateProductDescription, {
      once: true,
    });
  }

  window.initPdpV2Sliders = initPdpV2Sliders;
  window.attemptInitPdpV2Sliders = attemptInitPdpV2Sliders;
  window.updateSliders = updateSliders;
  window.queueInitPdpV2Sliders = queueInitPdpV2Sliders;
  window.queueSliderReinit = queueInitPdpV2Sliders;

  if (
    window.tolstoyWidget &&
    typeof window.tolstoyWidget.postMessage === "function"
  ) {
    updateProductDescription();
  } else {
    bindTolstoyListener();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleInit(250);
    });
  } else {
    scheduleInit(250);
  }

  window.addEventListener("load", function () {
    scheduleInit(0);
  });

  window.addEventListener("pageshow", function () {
    scheduleInit(0);
  });
})();
